// @flow
import * as React from 'react';
import {ReactComponent as Loading} from '../assets/loading.svg';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    loading?: boolean;
}
export const Button = (props: Props) => {
    const {loading, children, disabled, ...rest} = props;

    return (
        <button
            disabled={disabled || loading}
            {...rest}
        >
            {loading ? (
                <div className="w-full flex justify-center items-center">
                    <Loading className="animate-spin fill-primary w-5" />
                </div>
            ) : (
                <>
                    {children}
                </>
            )}
        </button>
    );
};